import React from 'react'
import { Image } from '../Image'
import { RichText } from '../RichText'
import { Text } from '../Text'
import { IProps } from './index'
import { mq } from '../../utils'

import { CardWithIcon as CardWithIconDefault } from './component'
import { BrandOptions, useBrand } from '../../providers/brandProvider'

export const CardWithIcon: React.FC<IProps> = (props: IProps) => {
  const theme = useBrand()
  if (theme === BrandOptions.default) {
    return <CardWithIconDefault {...props} />
  }
  return <CardWithIconLegacy {...props} />
}

const CardWithIconLegacy: React.FC<IProps> = ({ title, body, icon, cta }) => (
  <div className="background">
    {/* Image */}
    <div className="card-icon">
      <Image {...icon} />
    </div>

    {/* Title */}
    {title && (
      <div className="title">
        <RichText html={title} />
      </div>
    )}

    {/* Body */}
    {body && (
      <div className="body">
        <Text size="body">{body}</Text>
      </div>
    )}

    {/* CTA */}
    {cta && <div className="cta">{cta()}</div>}

    <style jsx>
      {`
        .background {
          display: grid;
          justify-items: center;
          height: 100%;
        }

        .card-icon {
          max-width: 70px;
          margin-bottom: 12px;
        }

        .title {
          margin-bottom: 14px;
          word-break: break-word;
          font-size: 26px;
          line-height: 1.2;
          text-align: center;

          :global(.rich-text p) {
            font-family: $fontGraphik;
            font-size: 26px;
            line-height: 132%;
            letter-spacing: 0.6px;
          }
        }

        .body {
          margin-bottom: 25px;
          text-align: center;
        }

        .cta {
          display: inline-block;
          align-self: flex-end;
        }

        @media (${mq.tablet}) {
          .background {
            justify-items: left;
          }

          .card-icon {
            margin-bottom: 30px;
          }

          .title {
            text-align: left;
          }

          .body {
            text-align: left;
          }
        }
      `}
    </style>
  </div>
)
